import React, {
  type CSSProperties,
  type ChangeEventHandler,
  forwardRef,
} from "react";

import clsx from "clsx";

import { useId } from "@floating-ui/react";

interface Props {
  checked?: boolean;
  disabled?: boolean;
  backgroundColor?: string;
  className?: string;
  onChange?: ChangeEventHandler;
}

export const CustomCheckbox = forwardRef<HTMLInputElement, Props>(
  ({ checked, disabled, backgroundColor, className, onChange }, ref) => {
    const id = useId();

    return (
      <div
        className={clsx("custom-checkbox", className, {
          "opacity-50": disabled,
        })}
        style={
          {
            "--custom-checkbox-bg-color": backgroundColor ?? "#7081FF",
          } as CSSProperties
        }
      >
        <input
          ref={ref}
          type="checkbox"
          id={id}
          checked={checked ?? false}
          disabled={disabled}
          readOnly
          onChange={onChange}
        />
        <label onClick={(e) => e.stopPropagation()} htmlFor={id}></label>
      </div>
    );
  },
);
